<template>
  <LoginCard :showCustomLogo="false">
    <svg viewBox="0 0 201 33" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.logo" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M56.598 20.364a7.584 7.584 0 01-7.584 7.584H46.93c-.217-2.528-2.825-4.678-6.513-5.676a6.585 6.585 0 10-9.25 0 11.458 11.458 0 00-4.758 2.415 11.465 11.465 0 00-2.76-1.135 5.635 5.635 0 10-7.89 0c-2.907.805-5.024 2.415-5.475 4.364H8.198a7.592 7.592 0 010-15.176c.965.003 1.921.19 2.818.548a7.568 7.568 0 016.915-4.404h.548a9.886 9.886 0 0118.178-3.22 8.05 8.05 0 0110.385 7.406 7.568 7.568 0 019.556 7.326v-.032zm10.466 6.795V14.278h-3.937v13.436c0 .902-.29 1.506-1.183 1.506a4.455 4.455 0 01-.926-.089l-.177 3.39c.42.069.846.11 1.272.12 3.655-.032 4.983-2.15 4.983-5.482h-.032zm11.705.805h3.849v-13.75h-3.913v7.647a2.65 2.65 0 01-2.721 2.923c-1.45 0-2.085-.95-2.085-2.375v-8.196h-3.937v9.299c0 2.987 1.337 4.83 3.937 4.83 2.174 0 3.856-1.393 4.637-4.025h.29l-.057 3.647zm10.57-7.648a2.673 2.673 0 012.754-2.898c1.417 0 2.085.957 2.085 2.35v8.196h3.937v-7.648a2.647 2.647 0 012.721-2.898c1.449 0 2.085.957 2.085 2.35v8.196h3.969v-9.315c0-2.987-1.36-4.83-4.025-4.83-2.262 0-3.824 1.417-4.573 4.106h-.322c-.169-2.577-1.36-4.106-3.792-4.106-2.173 0-3.824 1.385-4.605 4.025h-.29v-3.679h-3.848V27.9h3.937l-.032-7.583zm33.596.805c0-4.726-1.715-7.246-4.726-7.246-2.198 0-3.703 1.45-4.428 3.848h-.257v-3.477h-3.945v18.13h3.945V24.38h.225c.701 2.415 2.174 4.026 4.46 4.026 2.987-.057 4.774-2.577 4.774-7.294l-.048.008zm-6.634 3.76c-1.682 0-2.777-1.273-2.777-3.22v-1.08c0-1.964 1.071-3.22 2.809-3.22 1.876 0 2.722 1.192 2.722 3.712 0 2.52-.814 3.8-2.722 3.8l-.032.007zm17.784-5.064l3.647-.7c-.491-3.326-2.23-5.266-6.312-5.266-4.371 0-7.036 2.745-7.036 7.415 0 4.669 2.721 7.092 7.06 7.092 3.913 0 5.853-1.996 6.32-5.184l-3.623-.87c-.29 1.417-.958 2.609-2.721 2.609-2.029 0-3.011-1.417-3.011-3.857 0-2.6 1.127-3.76 2.955-3.76 1.827 0 2.407 1.031 2.753 2.512l-.032.009zm9.87-10.466h-3.905v18.597h3.937l-.032-18.597zm9.274 19c4.372 0 7.036-2.754 7.036-7.246 0-4.493-2.753-7.246-7.036-7.246-4.283 0-7.1 2.665-7.1 7.246 0 4.58 2.672 7.245 7.132 7.245h-.032zm0-11.207c2.174 0 3.124 1.417 3.124 3.904 0 2.488-.926 3.945-3.124 3.945s-3.131-1.449-3.131-3.945c0-2.495.958-3.904 3.131-3.904zm17.985 10.804h3.848V14.213h-3.96v7.648a2.658 2.658 0 01-2.73 2.923c-1.441 0-2.085-.95-2.085-2.375v-8.196h-3.936v9.299c0 2.987 1.336 4.83 3.936 4.83 2.174 0 3.856-1.393 4.637-4.025h.29v3.63zm15.377 0h3.937V9.35h-3.945v8.34h-.258c-.724-2.415-2.206-3.848-4.404-3.848-3.01 0-4.749 2.576-4.749 7.35 0 4.637 1.739 7.157 4.693 7.157 2.287 0 3.792-1.61 4.484-4.025h.234l.008 3.623zm-2.778-3.076c-1.94 0-2.785-1.215-2.785-3.679 0-2.463.869-3.792 2.753-3.792 1.739 0 2.81 1.272 2.81 3.277v1.087c-.008 1.892-1.127 3.107-2.778 3.107zM67.257 10.382a2.126 2.126 0 11-4.251 0 2.126 2.126 0 014.251 0z" fill="#002B49"/></svg>
    <h1 :class="$style.header">
      Administrator Login
    </h1>
    <LoginAlert
      v-if="errorDescription"
      data-test-id="error-alert"
      centered
      :class="$style.alertMarginBottom"
      :message="errorDescription"
    />
    <form
      autocomplete="on"
      method="post"
    >
      <LoginTextField
        autoFocus
        @focus="updateAutofocus('email')"
        :label="uiLabel.email"
        name="email"
        placeholder="Administrator Email Address"
        required
        :submitOnEnter="handleClick"
        type="email"
        vvName="email"
        v-model="userLoginStore.email"
      />
      <Checkbox
        :class="$style.rememberEmail"
        :label="uiLabel.rememberMe"
        v-model="userLoginStore.shouldRememberEmail"
        @input="handleInput"
      />
      <LoginActionButton
        :action="handleClick"
        data-automation="loginButton"
        :disabled="disableButton"
        :isLoading="isLoading"
        type="submit"
      >
        {{ uiLabel.continue }}
      </LoginActionButton>
    </form>
    <div :class="$style.seperator">
      or
    </div>
    <GoogleSignIn
      :error="errorParams.error"
      :class="$style.googleSignInContainer"
    />
  </LoginCard>
</template>
<script>
import { mapStores } from 'pinia';
import Checkbox from 'client/components/forms/Checkbox.vue';
import GoogleSignIn from 'client/components/GoogleSignIn.vue';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginAlert from 'client/components/LoginAlert.vue';
import LoginCard from 'client/components/LoginCard.vue';
import LoginTextField from 'client/components/LoginTextField.vue';
import UserLoginStore from 'client/stores/UserLoginStore';

// Services
import LocalStorageService from 'client/util/LocalStorageService';
import adminLoginService from 'client/services/adminLoginService';
// Constants
import { LocalStorageConsts, LoginConsts } from 'client/util/Constants';
import { useLoginLabels } from 'client/util/Constants/LoginLabels';
// Utils
import { datadogRum } from '@datadog/browser-rum-slim';
import RequestError from 'client/services/response/RequestError';
import loginUtil from 'client/components/mixins/loginUtil';

const { admin } = LoginConsts.clientType;

const {
  userLoginEmail,
} = LocalStorageConsts;

const {
  responseMessages,
} = LoginConsts;

export default {
  name: 'AdminEmailEntry',

  mixins: [loginUtil],

  components: {
    Checkbox,
    GoogleSignIn,
    LoginAlert,
    LoginActionButton,
    LoginCard,
    LoginTextField,
  },
  setup() {
    const uiLabel = useLoginLabels();
    return { uiLabel };
  },
  props: {
    clientType: {
      type: String,
      default: admin,
    },
    errorParams: {
      type: Object,
      default: () => ({ error: undefined, lockoutTime: undefined }),
    },
    onError: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapStores(UserLoginStore),

    disableButton() {
      const errors = this.$validator.errors.items.length > 0;

      return errors || !this.userLoginStore.email.length;
    },

    errorDescription() {
      let description = '';
      if (this.errorParams.error) {
        description = responseMessages[this.errorParams.error] || responseMessages.unexpected_error;
      }

      if (this.errorParams.error === 'lockedTemp') {
        if (this.errorParams.lockoutTime) {
          description = description.replace('%s', this.errorParams.lockoutTime);
        } else {
          description = responseMessages.lockedError;
        }
      }
      return description;
    },
  },
  mounted() {
    try {
      // ZR-1287 Check for EU based logins and move on to password entry
      const hasLoginHint = !!this.$route.query.login_hint;
      if (hasLoginHint) {
        this.userLoginStore.email = this.$route.query.login_hint;
        this.handleClick();
      }
    } catch { /* do nothing */ }
  },
  methods: {
    async handleClick() {
      this.isLoading = true;
      const { email, shouldRememberEmail } = this.userLoginStore;

      try {
        if (shouldRememberEmail) {
          LocalStorageService.setItem(userLoginEmail, email);
        }

        await adminLoginService.submitEmail({
          email,
          loginChallenge: this.$route.query.login_challenge,
        });
        this.changeStep('password');
      } catch {
      // TODO the exact error when email is wrong is pending to be discussed
        this.onError(new RequestError(0, responseMessages.access_denied));
      } finally {
        this.isLoading = false;
      }
    },

    changeStep(step) {
      this.$emit('changeStep', step);
    },

    handleFocus() {
      if (!this.hasTracked) {
        this.hasTracked = true;
        // Identify JS errors that cause the page not to load for specific browsers
        datadogRum.addAction('user-ready');
      }
    },
    handleInput(isChecked) {
      if (!isChecked) {
        LocalStorageService.removeItem(userLoginEmail);
      }
    },
  },
};
</script>
<style module>
@import '../../../css/login-components.css';

.alertMarginBottom {
  margin-bottom: 1.5rem;
  margin-top: 0;
}

.googleSignInContainer {
  margin-bottom: 3rem;
}

.seperator {
  margin: 0 0 1.5rem;
  opacity: 0.5;
  text-transform: uppercase;
}

.rememberEmail {
  display: flex;
  font-size: 0.875rem;
  margin-top: -0.75rem; /** override .loginFieldset margin from input.css */
  text-align: left;
}
</style>
